<template>
    <div>
        <h1 class="text-h5 my-5">
            Notification integrations
            <v-progress-circular v-if="loading" indeterminate color="green" class="ml-2"/>
        </h1>
        <v-alert v-if="alert.msg" :color="alert.color" icon="mdi-alert-octagon-outline" outlined text dismissible>
            {{alert.msg}}
        </v-alert>
        <v-simple-table>
            <thead>
                <tr>
                    <th>Provider</th>
                    <th>Default for alerting</th>
                    <th>Default for deployments tracking</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="i in integrations">
                    <td>
                        <div v-if="i.slack">
                            Slack
                            <div class="caption grey--text">
                                workspace: {{i.slack.team_name}}
                            </div>
                        </div>
                        <div v-if="i.teams">MS Teams</div>
                        <div v-if="i.pagerduty">Pagerduty</div>
                        <div v-if="i.opsgenie">Opsgenie</div>
                        <div v-if="i.webhook">Webhook</div>
                    </td>
                    <td>
                        <v-icon v-if="i.default_for_incidents" color="success">mdi-check-circle</v-icon>
                    </td>
                    <td>
                        <v-icon v-if="i.default_for_deployments" color="success">mdi-check-circle</v-icon>
                    </td>
                    <td>
                        <div class="d-flex">
                            <v-btn icon small @click="open(i, 'edit')" :disabled="!canEdit"><v-icon small>mdi-pencil</v-icon></v-btn>
                            <v-btn icon small @click="open(i, 'del')" :disabled="!canEdit"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                        </div>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <div v-if="!integrations" class="mt-3 text-center grey--text">
            Looks like you don't have any integration configured.
        </div>

        <v-menu offset-y>
            <template #activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" :disabled="!canEdit" color="primary"  class="mt-4">
                    Add an integration
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item @click="open({key: '', slack_init: {client_id: slackClientId}}, 'add')">
                    Slack
                </v-list-item>
                <v-list-item @click="open({key: '', teams: {}}, 'add')">
                    MS Teams
                </v-list-item>
                <v-list-item @click="open({key: '', pagerduty: {}}, 'add')">
                    Pagerduty
                </v-list-item>
                <v-list-item @click="open({key: '', opsgenie: {}}, 'add')">
                    Opsgenie
                </v-list-item>
                <v-list-item @click="open({key: '', webhook: {basic_auth: null, custom_headers: null}}, 'add')">
                    Webhook
                </v-list-item>
            </v-list>
        </v-menu>
        <IntegrationFormSlack v-if="action && (integration.slack || integration.slack_init || integration.slack_connect)" v-model="action" :integration="integration" />
        <IntegrationFormTeams v-if="action && integration.teams" v-model="action" :integration="integration" />
        <IntegrationFormPagerduty v-if="action && integration.pagerduty" v-model="action" :integration="integration" />
        <IntegrationFormOpsgenie v-if="action && integration.opsgenie" v-model="action" :integration="integration" />
        <IntegrationFormWebhook v-if="action && integration.webhook" v-model="action" :integration="integration" />
    </div>
</template>

<script>
import IntegrationFormSlack from "./IntegrationFormSlack.vue";
import IntegrationFormTeams from "./IntegrationFormTeams.vue";
import IntegrationFormPagerduty from "./IntegrationFormPagerduty.vue";
import IntegrationFormOpsgenie from "./IntegrationFormOpsgenie.vue";
import IntegrationFormWebhook from "./IntegrationFormWebhook.vue";

export default {
    props: {
        workspaceId: String,
        type: String,
    },

    components: {IntegrationFormSlack, IntegrationFormTeams, IntegrationFormPagerduty, IntegrationFormOpsgenie, IntegrationFormWebhook},

    data() {
        return {
            access: '',
            integrations: [],
            slackClientId: '',
            loading: false,
            alert: {msg: '', color: ''},
            form: '',
            action: '',
            integration: {},
        };
    },

    computed: {
        canEdit() {
            return this.access === 'edit';
        },
    },

    mounted() {
        this.get();
    },

    watch: {
        action(v) {
            !v && this.get();
        },
    },

    methods: {
        open(i, action) {
            if (!this.canEdit) {
                return;
            }
            this.integration = i;
            this.action = action;
        },
        get() {
            // this.integrations = [];
            this.loading = true;
            this.$api.getIntegrations((data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.alert.msg = 'Failed to get integrations. Please try again later.'
                    this.alert.color = 'red';
                }
                this.access = data.access;
                this.slackClientId = data.slack_client_id;
                this.integrations = data.integrations || [];
                if (!this.canEdit) {
                    this.alert.msg = 'You are not allowed to configure integrations.'
                    this.alert.color = 'primary';
                }
                if (this.$route.query.code) {
                    this.open({key: '', slack_connect: {code: this.$route.query.code}}, 'add');
                }
            });
        },
    },
};
</script>

<style scoped>
</style>
